<template>
    <div id="ContainerClinicalChartReview">
        <ChartReviewBase v-bind:Origin="'Clinical'" />
    </div>
</template>
<script>
import ChartReviewBase from "@/components/pages/chartreview/ChartReview";
import { EventBus } from '@/event-bus.js';

export default {
    name: 'ClinicalChartReview',
    mixins: [ChartReviewBase],

    created(){
        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
    },
};
</script>